export default [{
  path: '/AboutCifiIntro',//投洽会简介
  name: 'IntroPage',
  meta: {
    title: '投洽会简介_关于投洽会_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/AboutCifi/IntroPage.vue')
},{
  path: '/AboutCifiLogo',//会标释义
  name: 'LogoPage',
  meta: {
    title: '会标释义_关于投洽会_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/AboutCifi/LogoPage.vue')
},{
  meta: {
    title: '组织结构_关于投洽会_中国国际投资贸易洽谈会'
  },
  path: '/AboutCifiORG',//组织结构
  name: 'ORGPage',
  component: () => import('@/view/AboutCifi/ORGPage.vue')
},{
  meta: {
    title: '主题_形式_关于投洽会_中国国际投资贸易洽谈会'
  },
  path: '/AboutCifiTheme',//主题、形式
  name: 'ThemePage',
  component: () => import('@/view/AboutCifi/ThemePage.vue')
},{
  meta: {
    title: '功能_关于投洽会_中国国际投资贸易洽谈会'
  },
  path: '/AboutCifiFunc',//功能
  name: 'FuncPage',
  component: () => import('@/view/AboutCifi/FuncPage.vue')
},{
  meta: {
    title: '组委会领导_关于投洽会_中国国际投资贸易洽谈会'
  },
  path: '/AboutCifiLeader',//组委会领导
  name: 'LeaderPage',
  component: () => import('@/view/AboutCifi/LeaderPage.vue')
},{
   meta: {
    title: '领导寄语_关于投洽会_中国国际投资贸易洽谈会'
  },
  path: '/AboutCifiMsg',//领导寄语
  name: 'MsgPage',
  component: () => import('@/view/AboutCifi/MsgPage.vue')
},{
   meta: {
    title: '五大洲的声音'
  },
  path: '/AboutCifiVoice',//五大洲的声音
  name: 'VoicePage',
  component: () => import('@/view/AboutCifi/VoicePage.vue')
},{
   meta: {
    title: '历届回望_关于投洽会_中国国际投资贸易洽谈会'
  },
  path: '/AboutCifiHisCifi',//历届回望
  name: 'HisCifiPage',
  component: () => import('@/view/AboutCifi/HisCifiPage.vue')
},{
   meta: {
    title: '迷人的厦门_关于投洽会_中国国际投资贸易洽谈会'
  },
  path: '/AboutCifiXM',//迷人的厦门
  name: 'XMPage',
  component: () => import('@/view/AboutCifi/XMPage.vue')
},{
   meta: {
    title: '迷人的厦门_景点详情_关于投洽会_中国国际投资贸易洽谈会'
  },
  path: '/AboutCifiXMTour',//迷人的厦门-景点详情
  name: 'TourDetPage',
  component: () => import('@/view/AboutCifi/TourDetail.vue')
},{
   meta: {
    title: '历届赞助机构_品牌合作_关于投洽会_中国国际投资贸易洽谈会'
  },
  path: '/AboutCifiSponsor',//历届赞助机构 品牌合作
  name: 'SponsorPage',
  component: () => import('@/view/AboutCifi/sponsor.vue')
},{
  meta: {
    title: '历届赞助机构_品牌合作公告图片_关于投洽会_中国国际投资贸易洽谈会'
  },
  path: '/AboutCifiSponsorPic',//历届赞助机构 品牌合作公告图片
  name: 'SponsorPicPage',
  component: () => import('@/view/AboutCifi/sponsorPic.vue')
},]




// WEBPACK FOOTER //
// ./src/router/aboutCifi.js